export interface IRealTimeStoreState {
    isInitialized: boolean;
    correlationId: string;
    storeType: string;
    isPublishedRecipient?: boolean;
    publishedAccessKind?: number | null;
    publishedAccessKey?: string;
}

export interface IAction<T> {
    actionType: string;

    //This is just for TypeScript compiler... no use of it other way.
    __typeCall: (state: T) => T;
}

export class Action<T> implements IAction<T> {
    actionType: string;

    constructor(actionType: string) {
        this.actionType = actionType;
    }

    //This is just for TypeScript compiler... no use of it other way.
    public __typeCall(state: T): T {
        return state;
    }
}

export interface IRealTimeAction<T> extends IAction<T> {
    isDispatchedByRealTimeCallback: boolean; //Do not set directly, infrastructure set this
    correlationId: string | null; // Do not set directly, infrastructure set this
}

export class RealTimeAction<T> implements IRealTimeAction<T> {
    isDispatchedByRealTimeCallback: boolean; //Do not set directly, infrastructure set this
    correlationId: string | null; //Do not set directly, infrastructure set this

    actionType: string;

    constructor(actionType: string) {
        this.actionType = actionType;
        this.isDispatchedByRealTimeCallback = false;
        this.correlationId = null;
    }

    //This is just for TypeScript compiler... no use of it other way.
    public __typeCall(state: T): T {
        return state;
    }
}

export type reducerFn<TState, TAction> = (state: TState, action: TAction) => void;
export type middlewareFn<TState, TAction> = (state: TState, action: TAction) => Promise<boolean>;

export interface IActionDispatcher<TActionTypes> {
    dispatch: (action: TActionTypes) => Promise<boolean>;

    setRealTimeConnection: (connection: any) => void;
}
